import {
  JOB_COUNT,
  JOB_COUNT_SUCCESSFUL,
  JOB_COUNT_FAILED,
  JOB_SEARCH_COUNT,
} from "./actionTypes"

export const jobCount = user => {
  return {
    type: JOB_COUNT,
    payload: { user },
  }
}

export const jobCountSuccessful = user => {
  return {
    type: JOB_COUNT_SUCCESSFUL,
    payload: user,
  }
}

export const jobCountFailed = user => {
  return {
    type: JOB_COUNT_FAILED,
    payload: user,
  }
}
export const jobSearchCount = user => {
  return {
    type: JOB_SEARCH_COUNT,
    payload:{ user},
  }
}
